'use strict';

module.exports = function($stateProvider, $urlRouterProvider) {

    //$urlRouterProvider.otherwise('/departments');

    $stateProvider

        .state('dashboard.wizard', {
            url: '/wizard',
            templateUrl: 'dashboard-wizard/dashboard-wizard.html',
            controller: 'dashboardWizardCtrl as ctrl',
            data: {
                authorizedRoles: ['admin', 'owner', 'mobileUser', 'viewer', 'supervisor', 'teamLeader']
            }
        })


        .state('dashboard.wizard.departments', {
            url: '/departments',
            views: {'modal-wizard@': {
                templateUrl: 'dashboard-wizard/departments/departments.html',
                controller: [
                    'departments',
                    'clients',
                    'toast',
                    "$uibModal",
                    "$http",
                    "$stateParams",
                    "$state",
                    "Authentication",
                    "$translate",
                    function(departments, clients, toast, $uibModal, $http, $stateParams, $state,Authentication,$translate) {
                        var vm = this;
                        vm.wizardData = $state.wizardData;
                        vm.title = $translate.instant('DASHBOARD.DASH_WIZARD.DEPARTMENT.TITLE');
                        vm.departments = departments;
                        vm.clients = clients;

                        this.selectDepartment = function(department) {
                            // console.log('department', department)
                            // console.log('vm.wizardData.department', vm.wizardData.department)
                            if (!vm.wizardData.department || vm.wizardData.department?.id !== department.id) {
                                // console.log('entro a if')
                                vm.wizardData.department = department;
                                // toast.success($translate.instant('DASHBOARD.DASH_WIZARD.DEPARTMENT.SELECT_DEPT_TOAST'));
                            }
                        };
                        this.Authentication=Authentication;

                        this.createDepartment = function()    {
                            $uibModal.open({
                                animation: true,
                                controller: ['$uibModalInstance', 'Department', 'Authentication', function($uibModalInstance, Department, Authentication) {
                                    var _this = this;
                                    this.Authentication = Authentication;

                                    this.department = {
                                        name: null,
                                        description: null
                                    };

                                    // console.log("Authentication.isAuthorized(['admin'])", Authentication.isAuthorized(['admin']));

                                    // aca
                                    // console.log('clients', clients);
                                    _this.clients = vm.clients.filter(clt=>(Authentication.isAuthorized(['admin']) || clt.owners.find(owner=>owner.id==Authentication.currentUser())))

                                    this.create = function() {
                                        if (!_this.department.name) {
                                            return;
                                        }

                                        _this.loading = true;
                                        Department.create(_this.department)
                                            .$promise.then(function(department) {
                                                $state.reload('dashboard')
                                                    .then(function() {
                                                        $uibModalInstance.close(department);
                                                        $state.go('dashboard.wizard.departments', {
                                                            /* departmentId: department.id */
                                                        });
                                                    });

                                            })
                                            .catch(function(error) {
                                                _this.loading = false;
                                                console.log(error);
                                            });
                                    };

                                }],
                                templateUrl: 'dashboard-departments/dashboardCreateDepartmentModal.html',
                                controllerAs: 'modal',
                                size: 'sm',
                                windowClass: 'dialog',
                                bindToController: true
                            }).result.then(function(department) {});
                        };

                        this.goToUsers = function() {
                            if (vm.wizardData.department) {
                                $state.go('dashboard.wizard.users');
                            }
                        }

                    }],
                controllerAs: 'vm'
            }},
            resolve: {
                clients: [
                  "Client",
                  function (Client) {
                    return Client.find({
                      filter: {
                        where:{"isOU":true},
                        include: ["owners"],
                      },
                    }).$promise.then(function (clients) {
                      return clients;
                    });
                  },
                ],
              },
            data: {
                authorizedRoles: ['admin', 'owner', 'mobileUser', 'viewer','supervisor','teamLeader']
            }
        })

        .state('dashboard.wizard.users', {
            url: '/users',
            views: {'modal-wizard@': {
                templateUrl: 'dashboard-wizard/users/users.html',
                controller: [
                    'departments',
                    'members',
                    'toast',
                    "$uibModal",
                    "$http",
                    "$stateParams",
                    "$state",
                    "$translate",
                    function(departments, members, toast, $uibModal, $http, $stateParams, $state, $translate) {

                        var vm = this;
                        vm.wizardData = $state.wizardData;
                        vm.title =  $translate.instant('DASHBOARD.DASH_WIZARD.USERS.TITLE');
                        // console.log('wizard "' + vm.title + '" loaded.');

                        // console.log('$state.wizardData users', $state.wizardData)

                        if (! vm.wizardData.department) {
                            toast.error($translate.instant('DASHBOARD.DASH_WIZARD.NOSELECT_ERR_TOAST.DEPT'));
                            $state.go('dashboard.wizard.departments');
                        } else	{
							vm.wizardData.members = members;
						}

                        this.inviteUsers = function() {
                            $uibModal.open({
                                animation: true,
                                controller: ['$uibModalInstance', 'Member', 'toast', '$state', function($uibModalInstance, Member, toast, $state) {
                                    var _this = this;
                                    this.members = [];
                                    this.list = [];

                                    this.new_members = [];

                                    this.addUserToList = function(item) {

                                        //_this.list.push(item);
                                        //_this.newUser = '';

                                        Member.find({ filter: { where: { email: item }}})
                                        .$promise
                                        .then(function(members)    {
                                            if (members.length > 0) {
                                                toast.error($translate.instant('DASHBOARD.DASH_WIZARD.USERS.INVITE_DUPLICATE_ERR_TOAST'));
                                            } else  {
                                              _this.list.push(item);
                                              _this.newUser = '';
                                            }
                                        }, function()   {
                                            toast.error($translate.instant('DASHBOARD.DASH_WIZARD.USERS.INVITE_ERR_TOAST'));
                                        });

                                    };

                                    this.removeChip = function(index) {
                                        _this.list.splice(index, 1);
                                    };

                                    this.inviteUsers = function() {
                                        if (!_this.list.length) {
                                            return;
                                        }

                                        _this.new_members = [];

                                        _this.loading = true;
                                        Member.invite({}, {
                                                emails: _this.list
                                            })
                                            .$promise
                                            .then(function() {
                                                
                                                //$uibModalInstance.close();
                                                //toast.success('El o los usuarios indicados han sido invitados');

                                                for (var index = 0; index < _this.list.length; ++index) {
                                                    var email = _this.list[index];
                                                    Member.upsert({
                                                            email: email,
                                                            firstName: 'Por',
                                                            lastName: 'Confirmar',
                                                            password: 'xxx123456xxxx',
                                                            tenantId: $state.wizardData.department.tenantId,
                                                            emailVerified: false
                                                        })
                                                        .$promise
                                                        .then(function(member) {

                                                            _this.new_members.push(member);

                                                            if (member.email === _this.list[_this.list.length - 1]) {

                                                                setTimeout(function () {

                                                                    $uibModalInstance.close(_this.new_members);
                                                                    // toast.success($translate.instant('DASHBOARD.DASH_WIZARD.USERS.INVITE_OK_TOAST'));

                                                                    $state.reload('dashboard')
                                                                        .then(function() {
                                                                            $state.go('dashboard.wizard.users', {
                                                                            });
                                                                        });

                                                                }, 500); // xxx
                                                            }

                                                        })
                                                        .catch(function(error) {
                                                            console.log(error);
                                                        });

                                                }

                                            })
                                            .catch(function(error) {
                                                console.log(error);
                                                _this.loading = true;
                                            });

                                    };
                                }],
                                templateUrl: 'dashboard-users/dashboardInviteUsersModal.html',
                                controllerAs: 'modal',
                                size: 'md',
                                windowClass: 'dialog',
                                bindToController: true
                            }).result.then(function(members) { vm.wizardData.members = vm.wizardData.members.concat(members); });
                        };

                        this.editUser = function() {
                            $uibModal.open({
                                animation: true,
                                controller: ["$uibModalInstance", "clients", "clientsAll", "members", "Member", "myTenant", "toast", "Company", function ($uibModalInstance, clients, clientsAll, members, Member, myTenant, toast, Company) {
                                    var _this = this;
                                    _this.clients = clients;
                                    _this.clientsAll = clientsAll;
                                    let tenant = myTenant.get();
                                    _this.member = {
                                        addedDirectly: true,
                                        emailVerified: true,
                                        tenantId: tenant.id,
                                        clients: []
                                    }

                                    _this.clientsSelected = _this.member.clients.map(clt => clt.id);

                                    this.members = members;
                                    // this.companys = [];
                                    // this.companysForDirective = []; // Companys for input-select directive

                                    this.companyList = [];
                                    // this.companiesForDirective = []; // Companies for input-select directive

                                    this.clickClient = (clientId) => {
                                        let idx = _this.clientsSelected.indexOf(clientId)
                                        if (idx == -1) {
                                            _this.clientsSelected.push(clientId);
                                        }
                                        else {
                                            _this.clientsSelected.splice(idx, 1);
                                        }
                                    }

                                    this.addUser = function () {
                                        delete _this.member.roles;
                                        delete _this.member.device;
                                        delete _this.member.$$hashKey;
                                        delete _this.member.company;
                                        Member.upsert(
                                            _this.member,
                                            function (member) {
                                                Member.addClients(
                                                    { memberId: member.id },
                                                    _this.clientsSelected
                                                ).$promise.then(function (data) {
                                                    $uibModalInstance.close([member]);
                                                });
                                            },
                                            function (err) {
                                                toast.success(err.data.error.message);
                                            }
                                        );
                                    };

                                    // this.getCompanys = function () {
                                    //     let uniqueCompanysSet = new Set();
                                    //     this.members.forEach(member => {
                                    //         if (member.company && member.company.trim() !== '') {
                                    //             uniqueCompanysSet.add(member.company); // No converting to lowercase here.
                                    //         }
                                    //     });
                                    //     this.companys = Array.from(uniqueCompanysSet);

                                    //     // Sort without case sensitivity.
                                    //     this.companys.sort((a, b) => {
                                    //         const companyA = a.toLowerCase();
                                    //         const companyB = b.toLowerCase();
                                    //         return companyA.localeCompare(companyB, 'es', { sensitivity: 'base' });
                                    //     });

                                    //     this.companysForDirective = this.companys;
                                    // }

                                    this.getCompanies = () => {
                                        Company.find().$promise.then(function (data) {
                                            // console.log('data', data);
                                            _this.companyList = JSON.parse(JSON.stringify(data));
                                            // console.log('_this.companyList', _this.companyList)
                                            return;
                                        })
                                        .catch(function (error) { 
                                            console.error(error);
                                        });
                                    }

                                    this.addClientsPlaces = function () {
                                        _this.clients = _this.clients.map(client => ({
                                            ...client,
                                            places: [] // Add "places" to client
                                        }));

                                        // Add places to each client
                                        _this.clients.forEach(client => {
                                            _this.clientsAll.forEach(place => {
                                                if (client.id === place.clientId) {
                                                    client.places.push(place);
                                                }
                                            });
                                        });
                                    }

                                    _this.getCompanies();
                                    _this.addClientsPlaces();
                                }],
                                resolve: {
                                    clients: [
                                      "Client",
                                      function (Client) {
                                        return Client.find({
                                          filter: {
                                            where:{"isOU":true},
                                          },
                                        }).$promise.then(function (clients) {
                                          return clients;
                                        });
                                      },
                                    ],
                                    clientsAll: [
                                        "Client",
                                        function (Client) {
                                          return Client.find()
                                          .$promise
                                          .then(function (clients) {
                                            // console.log('clientsAll en config', clients);
                                            return clients;
                                          });
                                        },
                                      ],
                                    members: ['Member', function(Member) {
                                        return Member
                                            .find({
                                                filter: {
                                                    include: ['clients','roles',{
                                                        relation: "device",                                    
                                                        scope: {
                                                          fields:["id","deviceId","model","isBrowser"],
                                                          where: { "isBrowser":{"neq":true}},
                                                        },
                                                      }]
                                                },                            
                                            })
                                            .$promise
                                            .then(function(data) {
                                                return data.sort((a,b)=>(a.lastName||"").localeCompare((b.lastName||"")));
                                            });
                                    }]
                                },
                                templateUrl: 'dashboard-users/dashboardAddUserModal.html',
                                controllerAs: 'modal',
                                size: 'xlg',
                                windowClass: 'dialog',
                                bindToController: true
                            }).result.then(function(members) { 
                                // console.log('members', members);
                                vm.wizardData.members = vm.wizardData.members.concat(members);
                                // funcion ordenar members por nombre
                            });
                        };
                    }],
                controllerAs: 'vm',

                resolve: {
                    members: ['Member', function(Member) {
                        return Member
                            .find({
                                filter: {
                                    include: ['roles','device']
                                }
                            })
                            .$promise
                            .then(function(data) {
                                return data;
                            });
                    }]
                },

            }}
        })

        .state('dashboard.wizard.owners', {
            url: '/owners',
            views: {'modal-wizard@': {
                templateUrl: 'dashboard-wizard/owners/owners.html',
                controller: [
                    'departments',
                    'toast',
                    "$uibModal",
                    "$http",
                    "$stateParams",
                    "$state",
                    "$translate",
                    function(departments, toast, $uibModal, $http, $stateParams, $state, $translate) {

                        var vm = this;
                        vm.wizardData = $state.wizardData;
                        vm.title = $translate.instant('DASHBOARD.DASH_WIZARD.OWNER.TITLE');
                        // console.log('wizard "' + vm.title + '" loaded.');

                        // console.log('$state.wizardData users owners', $state.wizardData)

                        if (! vm.wizardData.department) {
                            toast.error($translate.instant('DASHBOARD.DASH_WIZARD.NOSELECT_ERR_TOAST.DEPT'));
                            $state.go('dashboard.wizard.departments');
                        } else if (! vm.wizardData.members.length) {
                            toast.error($translate.instant('DASHBOARD.DASH_WIZARD.NOSELECT_ERR_TOAST.USERS_OK'));
                            $state.go('dashboard.wizard.users');
                        }

                        this.addOwner = function() {
                            $uibModal.open({
                                animation: true,
                                controller: ['$uibModalInstance', '$stateParams', 'Department', 'currentMembers', function($uibModalInstance, $stateParams, Department, currentMembers) {
                                    var _this = this;
                                    this.members = [];
                                    this.currentMembers = currentMembers;

                                    this.addUsers = function() {

                                        if (!_this.members.length) {
                                            return;
                                        }
                                        
                                        _this.loading = true;
                                        Department.addOwner({
                                                departmentId: vm.wizardData.department.id,
                                            }, {
                                                id: _this.members.map(function(member) {
                                                    return member.id;
                                                })
                                            })
                                            .$promise
                                            .then(function(member) {
                                                $uibModalInstance.close(member.response);
                                            })
                                            .catch(function(error) {
                                                _this.loading = false;
                                                console.log(error);
                                            });

                                    };
                                }],
                                templateUrl: 'dashboard-department-admin/dashboardAddUsersModal.html',
                                controllerAs: 'modal',
                                size: 'md',
                                windowClass: 'dialog',
                                bindToController: true,
                                resolve: {
                                    currentMembers: function() {
                                        return vm.wizardData.department.owners;
                                    }
                                }
                            }).result.then(function(members) {
                                vm.wizardData.department.owners = vm.wizardData.department.owners.concat(members);
                            });
                        };

                        this.goToTeams = function() {
                            if (vm.wizardData.department.owners.length) {
                                $state.go('dashboard.wizard.teams');
                            }
                        }

                    }],
                controllerAs: 'vm'
            }}
        })

        .state('dashboard.wizard.teams', {
            url: '/teams',
            views: {'modal-wizard@': {
                templateUrl: 'dashboard-wizard/teams/teams.html',
                controller: [
                    'departments',
                    'teams',
                    'toast',
                    "$uibModal",
                    "$http",
                    "$stateParams",
                    "$state",
                    "$translate",
                    function(departments, teams, toast, $uibModal, $http, $stateParams, $state, $translate) {

                        var vm = this;
                        vm.wizardData = $state.wizardData;
                        vm.title = $translate.instant('DASHBOARD.DASH_WIZARD.TEAM.TITLE');
                        // console.log('wizard "' + vm.title + '" loaded.');

                        // console.log('$state.wizardData teams', $state.wizardData)

                        if (! vm.wizardData.department) {
                            toast.error($translate.instant('DASHBOARD.DASH_WIZARD.NOSELECT_ERR_TOAST.DEPT'));
                            $state.go('dashboard.wizard.departments');
                        } else if (! vm.wizardData.department.owners.length) {
                            toast.error($translate.instant('DASHBOARD.DASH_WIZARD.NOSELECT_ERR_TOAST.OWNER'));
                            $state.go('dashboard.wizard.owners');
                        } else if (! vm.wizardData.members.length) {
                            toast.error($translate.instant('DASHBOARD.DASH_WIZARD.NOSELECT_ERR_TOAST.USERS_OK'));
                            $state.go('dashboard.wizard.users');
                        } else	{
							vm.wizardData.teams = teams;
						}

                        this.selectTeam = function(team)    {
                            vm.wizardData.team = team;
                            // toast.success($translate.instant('DASHBOARD.DASH_WIZARD.TEAM.SELECT_OK'));
                        };

                        this.createTeam = function() {
                            $uibModal.open({
                                animation: true,
                                controller: ['$uibModalInstance', '$http', '$stateParams', '$state', 'Department', function($uibModalInstance, $http, $stateParams, $state, Department) {
                                    var _this = this;
                                    this.team = {
                                        name: ''
                                    };

                                    this.create = function() {
                                        if (!_this.team.name) {
                                            return;
                                        }

                                        _this.loading = true;
                                        Department.teams.create({
                                                id: $state.wizardData.department.id
                                            }, _this.team)
                                            .$promise
                                            .then(function(team) {
                                                //$uibModalInstance.close(team);

                                                $state.reload('dashboard')
                                                    .then(function() {
                                                        $uibModalInstance.close(team);
                                                        $state.go('dashboard.wizard.teams', {
                                                            /* departmentId: department.id */
                                                        });
                                                    });

                                            })
                                            .catch(function(error) {
                                                console.log(error);
                                                _this.loading = false;
                                            });
                                    };

                                }],
                                templateUrl: 'dashboard-teams/dashboardCreateTeamModal.html',
                                controllerAs: 'modal',
                                size: 'sm',
                                windowClass: 'dialog',
                                bindToController: true
                            }).result.then(function(team) {});
                        };

                        this.goToTeamUsers = function() {
                            if (vm.wizardData.team) {
                                $state.go('dashboard.wizard.teamusers');
                            }
                        }

                    }],
                controllerAs: 'vm',

                resolve: {
                    teams: ['Department', '$stateParams', '$state', function(Department, $stateParams, $state) {
                        return Department
                            .teams({
                                filter: {
                                    include: 'members'
                                },
                                id: $state.wizardData.department ? $state.wizardData.department.id : 0
                            })
                            .$promise
                            .then(function(teams) {
                                return teams;
                            }  , function () { return {}; }  );
                    }]
                },

            }}
        })

        .state('dashboard.wizard.teamusers', {
            url: '/teamusers',
            views: {'modal-wizard@': {
                templateUrl: 'dashboard-wizard/teamusers/teamusers.html',
                controller: [
                    'departments',
                    'toast',
                    '$uibModal',
                    "$http",
                    "$stateParams",
                    "$state",
                    "$translate",
                    function(departments, toast, $uibModal, $http, $stateParams, $state, $translate) {

                        var vm = this;
                        vm.wizardData = $state.wizardData;
                        vm.title = $translate.instant('DASHBOARD.DASH_WIZARD.TEAMUSERS.TITLE');
                        // console.log('wizard "' + vm.title + '" loaded.');

                        // console.log('$state.wizardData teamusers', $state.wizardData)

                        if (! vm.wizardData.department) {
                            toast.error($translate.instant('DASHBOARD.DASH_WIZARD.NOSELECT_ERR_TOAST.DEPT'));
                            $state.go('dashboard.wizard.departments');
                        } else if (! vm.wizardData.department.owners.length) {
                            toast.error($translate.instant('DASHBOARD.DASH_WIZARD.NOSELECT_ERR_TOAST.OWNER'));
                            $state.go('dashboard.wizard.owners');
                        } else if (! vm.wizardData.members.length) {
                            toast.error($translate.instant('DASHBOARD.DASH_WIZARD.NOSELECT_ERR_TOAST.USERS_OK'));
                            $state.go('dashboard.wizard.users');
                        } else if (! vm.wizardData.team) {
                            toast.error($translate.instant('DASHBOARD.DASH_WIZARD.NOSELECT_ERR_TOAST.TEAM'));
                            $state.go('dashboard.wizard.teams');
                        }

                        this.addUsers = function() {
                            $uibModal.open({
                                animation: true,
                                controller: ['$uibModalInstance', '$stateParams', '$state', 'Department', 'currentTeamMembers',
                                    function($uibModalInstance, $stateParams, $state, Department, currentTeamMembers) {
                                        this.members = [];
                                        this.currentTeamMembers = currentTeamMembers;
                                        var _this = this;
                                        this.loading = false;
                                        this.isTeamLeader = false;

                                        this.addUsers = function() {
                                            if (!_this.members.length) {
                                                return;
                                            }

                                            this.loading = true;
                                            Department.addTeamMember({
                                                    departmentId: $state.wizardData.department.id,
                                                    teamId: $state.wizardData.team.id
                                                }, {
                                                    ids: _this.members.map(function(member) {
                                                        return member.id;
                                                    })
                                                })
                                                .$promise
                                                .then(function(member) {
                                                    //$uibModalInstance.close(member.response);
                                                    $state.reload('dashboard')
                                                        .then(function() {
                                                            $uibModalInstance.close(member.response);
                                                            $state.go('dashboard.wizard.teamusers', {
                                                                /* departmentId: department.id */
                                                            });
                                                        });

                                                })
                                                .catch(function(error) {
                                                    this.loading = false;
                                                    console.log(error);
                                                });
                                        };

                                        this.checkTeamLeader = function () {
                                            // console.log('_this.isTeamLeader2', _this.isTeamLeader);
                                            _this.isTeamLeader = !_this.isTeamLeader;
                                        }
                                    }
                                ],
                                templateUrl: 'dashboard-team/dashboardAddUsersModal.html',
                                controllerAs: 'modal',
                                size: 'md',
                                windowClass: 'dialog',
                                bindToController: true,
                                resolve: {
                                    currentTeamMembers: function() {
                                        return vm.wizardData.team.members || [];
                                    }
                                }
                            }).result.then(function(members) {
                                // _this.team.members = _this.team.members.concat(members);
                                vm.wizardData.team.members = vm.wizardData.team.members.concat(members);
                            });
                        };

                        this.goToForms = function() {
                            if (vm.wizardData.team.members.length) {
                                $state.go('dashboard.wizard.forms');
                            }
                        }

                    }],
                controllerAs: 'vm'
            }}
        })

        .state('dashboard.wizard.forms', {
            url: '/forms',
            views: {'modal-wizard@': {
                templateUrl: 'dashboard-wizard/forms/forms.html',
                controller: [
                    'departments',
                    'forms',
                    'toast',
                    'dialog',
                    "$http",
                    "$stateParams",
                    "$state",
                    "$translate",
                    function(departments, forms, toast, dialog, $http, $stateParams, $state, $translate) {

                        var vm = this;
                        vm.wizardData = $state.wizardData;
                        vm.title = $translate.instant('DASHBOARD.DASH_WIZARD.FORMS.TITLE');
                        // console.log('wizard "' + vm.title + '" loaded.');

                        // console.log('$state.wizardData forms', $state.wizardData)

                        if (! vm.wizardData.department) {
                            toast.error($translate.instant('DASHBOARD.DASH_WIZARD.NOSELECT_ERR_TOAST.DEPT'));
                            $state.go('dashboard.wizard.departments');
                        } else if (! vm.wizardData.department.owners.length) {
                            toast.error($translate.instant('DASHBOARD.DASH_WIZARD.NOSELECT_ERR_TOAST.OWNER'));
                            $state.go('dashboard.wizard.owners');
                        } else if (! vm.wizardData.members.length) {
                            toast.error($translate.instant('DASHBOARD.DASH_WIZARD.NOSELECT_ERR_TOAST.USERS_OK'));
                            $state.go('dashboard.wizard.users');
                        } else if (! vm.wizardData.team) {
                            toast.error($translate.instant('DASHBOARD.DASH_WIZARD.NOSELECT_ERR_TOAST.TEAM'));
                            $state.go('dashboard.wizard.teams');
                        } else if (! vm.wizardData.team.members.length) {
                            toast.error($translate.instant('DASHBOARD.DASH_WIZARD.NOSELECT_ERR_TOAST.TEAM_USERS'));
                            $state.go('dashboard.wizard.teams');
                        } else	{
							vm.wizardData.forms = forms;
						}

                        this.selectForm = function(form)    {
                            vm.wizardData.form = form;
                            // toast.success($translate.instant('DASHBOARD.DASH_WIZARD.FORMS.SELECT_OK'));

                            // $state.wizardData.uibModalInstance.dismiss();

                            // $state.go('dashboard.departments.department.forms.form.builder', {
                            //     departmentId: vm.wizardData.department.id,
                            //     formId: form.id
                            // });

                            const url = $state.href('dashboard.departments.department.forms.form.builder', {
                                departmentId: vm.wizardData.department.id,
                                formId: form.id
                            });

                            // Open new tab
                            window.open(url, '_blank');
                        };

                        this.createForm = function() {
                            dialog.confirm({
                                title: $translate.instant('DASHBOARD.DASH_WIZARD.FORMS.DIAG_NEW.TITLE'),
                                body: $translate.instant('DASHBOARD.DASH_WIZARD.FORMS.DIAG_NEW.BODY'),
                                accept: $translate.instant('DASHBOARD.DASH_WIZARD.FORMS.DIAG_NEW.ACCEPT'),
                                cancel: $translate.instant('DASHBOARD.CANCEL'),
                                size: 'sm'
                            }).then(function() {

                                // $state.wizardData.uibModalInstance.dismiss();

                                // $state.go('dashboard.departments.department.forms.form.builder', {
                                //     departmentId: vm.wizardData.department.id,
                                //     formId: 'new'
                                // });

                                const url = $state.href('dashboard.departments.department.forms.form.builder', {
                                    departmentId: vm.wizardData.department.id,
                                    formId: 'new'
                                });

                                // Open new tab
                                window.open(url, '_blank');
                            });

                        };


                    }],
                controllerAs: 'vm',

                resolve: {
                    forms: ['Department', '$stateParams', 'departments', '$state', function (Department, $stateParams, departments, $state) {
                        return Department.forms({
                                id: $state.wizardData.department ? $state.wizardData.department.id : 0,
                                filter: {
                                    fields: ['id', 'name', 'description', 'tenantId', 'departmentId', 'subscribed'],
                                    include: [{
                                        relation: 'teams',
                                        scope: {
                                            fields: 'id'
                                        }
                                    }, 'tenant']
                                }
                            })
                            .$promise.then(function (forms) {
                                return forms;
                            }  , function () { return {}; }  );
                    }]
                },

            }}
        });

};
